import { createContext, useContext, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { StaffingForm } from "./StaffingForm";

const StaffingContext = createContext({ open: () => {}, close: () => {} });

export const useStaffing = () => useContext(StaffingContext);

export function StaffingProvider({ children }) {
  const [isOpen, setIsOpen] = useState(false);
  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);

  return (
    <StaffingContext.Provider value={{ open, close }}>
      {children}
      <Dialog open={isOpen} onOpenChange={setIsOpen}>
        <DialogContent
          className="max-h-[92vh] overflow-y-auto border-white/10 bg-ink-800 text-white sm:max-w-lg"
          data-testid="staffing-dialog"
        >
          <DialogHeader>
            <DialogTitle className="font-heading text-2xl font-bold tracking-tight">
              Submit a Staffing Requirement
            </DialogTitle>
            <DialogDescription className="text-slate-400">
              Tell us the roles you need. Our team will respond quickly with a plan.
            </DialogDescription>
          </DialogHeader>
          <StaffingForm onDone={close} />
        </DialogContent>
      </Dialog>
    </StaffingContext.Provider>
  );
}
